import ApolloClient from 'apollo-boost';
import gql from 'graphql-tag';

// TODO: restructure this file
const INVOICE_QUERY = gql`
  query getInvoiceById($invoiceId: Int!, $paymentCode: String!) {
    getInvoice(invoiceId: $invoiceId, paymentCode: $paymentCode) {
      invoiceId
      accountId
      invoiceStatusName
      amount
      tax
      balanceDue
      taxExempt
      poNumber
      paymentCode
      subscriptionStartDate
      subscriptionEndDate
      lineItemDesc
      additionalNotes
      invoicePayments {
        invoicePaymentId
        amount
        paidDate
      }
      creditCard {
        accountCreditId
        accountId
        ccDisplay
      }
    }
  }
`;

const INVOICE_BALANCE_QUERY = gql`
  query getInvoiceById($invoiceId: Int!, $paymentCode: String!) {
    getInvoice(invoiceId: $invoiceId, paymentCode: $paymentCode) {
      balanceDue
    }
  }
`;

const PAY_MUTATION = gql`
  mutation pay(
    $invoiceId: Int!
    $paymentCode: String!
    $amount: Float!
    $paidByCC: Boolean!
    $accountCreditId: Int
    $cvn: String!
  ) {
    pay(
      paymentInput: {
        invoiceId: $invoiceId
        paymentCode: $paymentCode
        amount: $amount
        paidByCC: $paidByCC
        accountCreditId: $accountCreditId
        cvn: $cvn
      }
    ) {
      invoicePaymentId
      confirmationNumber
      created
    }
  }
`;

const ADD_CARD_MUTATION = gql`
  mutation addCard(
    $invoiceId: Int!
    $paymentCode: String!
    $accountId: Int!
    $billingAddress1: String!
    $billingAddress2: String
    $billingCity: String!
    $billingState: String!
    $billingZipCode: String!
    $firstName: String!
    $lastName: String!
    $cvn: String!
    $expirationDate: Date!
    $cardNumber: String!
    $saveCC: Boolean!
  ) {
    addCard(
      creditCardInput: {
        invoiceId: $invoiceId
        paymentCode: $paymentCode
        accountId: $accountId
        billingAddress1: $billingAddress1
        billingAddress2: $billingAddress2
        billingCity: $billingCity
        billingState: $billingState
        billingZipCode: $billingZipCode
        firstName: $firstName
        lastName: $lastName
        cvn: $cvn
        expirationDate: $expirationDate
        cardNumber: $cardNumber
        saveCC: $saveCC
      }
    ) {
      accountCreditId
      accountId
      ccDisplay
    }
  }
`;

const EDIT_PO_MUTATION = gql`
  mutation editPO(
    $invoiceId: Int!
    $paymentCode: String!
    $poNumber: String
    $additionalNotes: String
  ) {
    editInvoice(
      invoiceInput: {
        invoiceId: $invoiceId
        paymentCode: $paymentCode
        poNumber: $poNumber
        additionalNotes: $additionalNotes
      }
    ) {
      poNumber
    }
  }
`;

export const INITIALIZE_TEST_MUTATION = gql`
  mutation {
    initializeTest
  }
`;

export const CLIENT_OPTIONS = {
  errorPolicy: 'all',
};

export const graphqlClient = new ApolloClient({
  uri: `${process.env.REACT_APP_PAYMENT_API_BASE_URL}/${process.env.REACT_APP_ENV}/graphql`,
});

export const getInvoiceByIdQuery = (invoiceId, paymentCode) => {
  const invoiceIdNum = parseInt(invoiceId, 10);
  return graphqlClient.query({
    query: INVOICE_QUERY,
    variables: { invoiceId: invoiceIdNum, paymentCode },
    fetchPolicy: 'network-only',
    ...CLIENT_OPTIONS,
  });
};

export const getInvoiceBalanceByIdQuery = (invoiceId, paymentCode) => {
  const invoiceIdNum = parseInt(invoiceId, 10);
  return graphqlClient.query({
    query: INVOICE_BALANCE_QUERY,
    variables: { invoiceId: invoiceIdNum, paymentCode },
    fetchPolicy: 'network-only',
    ...CLIENT_OPTIONS,
  });
};

export const postPaymentMutation = (paymentInput) => {
  const { invoiceId, paymentCode, amount, paidByCC, accountCreditId, cvn } =
    paymentInput;
  const invoiceIdNum = parseInt(invoiceId, 10);
  const amountFloat = parseFloat(amount);

  return graphqlClient.mutate({
    mutation: PAY_MUTATION,
    variables: {
      invoiceId: invoiceIdNum,
      paymentCode,
      amount: amountFloat,
      paidByCC,
      accountCreditId,
      cvn,
    },
    ...CLIENT_OPTIONS,
  });
};

export const addCreditCardMutation = (creditCardInput) => {
  const {
    invoiceId,
    paymentCode,
    accountId,
    billingAddress1,
    billingAddress2,
    billingCity,
    billingState,
    billingZipCode,
    firstName,
    lastName,
    cvn,
    expirationDate,
    cardNumber,
    saveCC,
  } = creditCardInput;

  const invoiceIdNum = parseInt(invoiceId, 10);

  return graphqlClient.mutate({
    mutation: ADD_CARD_MUTATION,
    variables: {
      invoiceId: invoiceIdNum,
      paymentCode,
      accountId,
      billingAddress1,
      billingAddress2,
      billingCity,
      billingState,
      billingZipCode,
      firstName,
      lastName,
      cvn,
      expirationDate,
      cardNumber,
      saveCC,
    },
    ...CLIENT_OPTIONS,
  });
};

export const updatePoMutation = (
  invoiceId,
  paymentCode,
  poNumber,
  additionalNotes
) =>
  graphqlClient.mutate({
    mutation: EDIT_PO_MUTATION,
    variables: {
      invoiceId,
      paymentCode,
      poNumber,
      additionalNotes,
    },
    ...CLIENT_OPTIONS,
  });
